import React, { ChangeEvent } from 'react';

import { Field, Grid, LegacyButton, TextInput } from '@zapier/design-system';

import VersionPicker from 'app/developer-v3/components/VersionPicker';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  buttonLabel: string;
  error: string;
  integrationId: number;
  onButtonClick: () => void;
  onChangeVersion: (selected: SemVer) => void;
  onUpdateField: (value: string) => void;
  version: SemVer;
};

function SharingForm({
  buttonLabel,
  error,
  integrationId,
  onButtonClick,
  onChangeVersion,
  onUpdateField,
  version,
}: Props) {
  return (
    <Field
      error={error}
      isRequired={true}
      label="Email"
      renderInput={inputProps => (
        <Grid alignItems="center" columns="1fr auto auto" gap="5px">
          <TextInput
            {...inputProps}
            aria-label="Add email for new invitee"
            aria-required={true}
            isFullWidth={true}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onUpdateField(e.target.value)
            }
          />
          <VersionPicker
            initialVersion={version}
            integrationId={integrationId}
            onChange={(versionNext: SemVer) => onChangeVersion(versionNext)}
          />
          <LegacyButton aria-label="Add invitee" onClick={onButtonClick}>
            {buttonLabel}
          </LegacyButton>
        </Grid>
      )}
    />
  );
}

export default SharingForm;
